import React from "react";
import { Link } from "react-router-dom";
import { mainServices } from "../../../Data/services";

const ServiceDetailsLeft = ({ services }) => {
  return (
    <section className=" w-full max-lg:w-[30%] px-5 max-sm:px-20 max-lg:px-0 order-last	 max-lg:order-none	">
      <div className="mb-[30px]">
        <ul>
          {mainServices.slice(0, 5).map((data, index) => (
            <li key={index} className="my-2">
              {" "}
              <Link
                to={`/service/${data.slug}`}
                className="text-[#000917] bg-[#e6ebf4] font-bold font-fira px-[40px] py-[14px] block text-[18px] hover:bg-primary hover:text-[#fff]"
              >
                {data.title}
              </Link>
            </li>
          ))}
        </ul>
      </div>
      <div
        className={`${services.services_contact} px-[60px] pb-[120px] pt-[108px] flex justify-center items-center flex-col`}
      >
        <h4 className="text-[#08d9ff] text-[15px] mb-1">Contact us now</h4>
        <h3 className="border-b mb-[10px] pb-[6px] text-4xl text-[#fff] w-full text-center border-[#0f67f652]">
          If need help!
        </h3>
        <p className="text-[#fff] text-[20px] max-sm:text-[36px] font-bold">
          +8809611745310
        </p>
        <p className="text-[#fff] mb-9 text-lg">or go to contact form:</p>
        <Link
          to="/contact"
          className="max-sm:pl-[29px] pl-2 pr-[30px] max-sm:pr-[58px] w-full max-xl:pr-[72px] bg-[#fff] inline-block relative text-[#000] text-sm font-semibold leading-[47px]"
        >
          Let’s start now
          <i className="fa-solid fa-link absolute right-0 top-0 h-[47px] w-[46px] leading-[47px]"></i>
        </Link>
      </div>
    </section>
  );
};

export default ServiceDetailsLeft;
